import SOETHeader from "./header";
import BreadcrumbsBanner from "./breadcrumbs";
import SOETContent from "./home";
import { Typography, Grid, Card, Avatar, Box } from '@mui/material';
import { Container } from "@mui/material";
import MainTitle from '../muiHome/mainTitle';
import SOETDepartments from "./departments";
import EventNewsGallary from "./eventNews";
import RecuiterCompany from "./recuiterCompany";
// import WidgetsMenu from "./menuWidgets";
import NewMain from "../headerone/newMain";



import { ListDataPresentation, ReactSlider, TableDataPresentation } from '../../utils/utils';
import WidgetsMenu from "../muiCommonComponent/menuWidgets";
const SOETHome=()=>{

    const SAHSfeeStructureData=[
        {'Courses':'B.Tech CSE','eligibility ':'10+2 with 50% marks in PCM','Duration':'4','Tuition Fee':'107000','1st Year Onwards Fees':'127000'},
        {'Courses':'B.Tech CSE (AI & ML)','eligibility ':'10+2 with 50% marks in PCM','Duration':'4','Tuition Fee':'128000','1st Year Onwards Fees':'148000'},
        {'Courses':'B.Tech CSE (Cyber Security)','eligibility ':'10+2 with 50% marks in PCM','Duration':'4','Tuition Fee':'107000','1st Year Onwards Fees':'127000'},
        {'Courses':'B.Tech Civil Engineering','eligibility ':'10+2 with 50% marks in PCM','Duration':'4','Tuition Fee':'70000','1st Year Onwards Fees':'90000'},
        {'Courses':'B.Tech ME (Robotics & Automation)','eligibility ':'10+2 with 50% marks in PCM','Duration':'4','Tuition Fee':'70000','1st Year Onwards Fees':'90000'},
        {'Courses':'M.Tech CSE','eligibility ':'B.Tech CSE with 50% marks','Duration':'2','Tuition Fee':'60000','1st Year Onwards Fees':'80000'},
        {'Courses':'B.Sc Computer Science','eligibility ':'10+2 with 50% marks in PCM','Duration':'3','Tuition Fee':'52000','1st Year Onwards Fees':'72000'},
        {'Courses':'BCA','eligibility ':'10+2 with 50% marks in Any Stream','Duration':'3','Tuition Fee':'57000','1st Year Onwards Fees':'77000'},
        {'Courses':'BCA (Data Science)','eligibility ':'10+2 with 50% marks in Any Stream','Duration':'3','Tuition Fee':'65000','1st Year Onwards Fees':'85000'},
        {'Courses':'BCA (AI & ML)','eligibility ':'10+2 with 50% marks in Any Stream','Duration':'3','Tuition Fee':'65000','1st Year Onwards Fees':'85000'},
        {'Courses':'MCA','eligibility ':'Graduate in Related Stream with 50% marks','Duration':'2','Tuition Fee':'45000','1st Year Onwards Fees':'65000'}
        ];
        
        
        
        
  

    const headerMenus = [
        { mainHeader: 'Home', path: '/school-of-engineering-technology', subHeader: [] },
        { mainHeader: 'SOET Insights', path: '', subHeader: [
            { title: 'Insights', path: '/soet/insights', },
            { title: 'Vision & Mission', path: '/soet/vision-mission', },
            { title: 'Knowledge Partners', path: '/soet/knowledge-partners', },
            { title: 'Pedagogical Advances – MOOCs', path: '/soet/mcoos', },
        ] },
        { mainHeader: 'SOET Departments', path: '', subHeader: [
            { title: 'Computer Science & Engineering', path: '/soet-cse/home', },
            { title: 'Mechanical Engineering', path: '/soet-me/home' },
            { title: 'Civil Engineering', path: '/soet-civil/home' },
            { title: 'Electronic & Communication Engineering', path: '/soet-ece/home' },
        ] },
        { mainHeader: 'Faculty', path: '/soet/Faculty', subHeader: [] },
        { mainHeader: 'MVN Times', path: '#', subHeader: [] },
        { mainHeader: 'Scholarly Work ', path: '#', subHeader: [] },
      ];


return(<>
<NewMain/>
{/* <Navbar/> */}
<WidgetsMenu headerMenus={headerMenus}/>
<BreadcrumbsBanner bannerUrl={"/assets/img/SOET/soet.jpg"}/>
<Container>
<SOETContent/>


<SOETDepartments/>
<EventNewsGallary/>
<RecuiterCompany/>



<Grid item xs={12} className="fee-struct_t">
					<MainTitle title='FEE STRUCTURE – 2026-27'/>
                   
				</Grid> 
				<Grid item xs={12}>
				<TableDataPresentation data={SAHSfeeStructureData}/>
				</Grid>



</Container>
</>)
}
export default SOETHome;